module.exports = __webpack_public_path__ + "img/antes_despues_199.1dc02cf3.png";